import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import dashboardTipoDocumentoService from "./dashboardTipoDocumentoService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class DashboardTipoDocumento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        listTipoDocumento:[],
        listTipoDocumentoOld:[],
        loading: false,
        loadingButton: false,
        idDaEliminare: null,
        showDeleteModal: false,
        showAddDocumentModal: false,
        newDocumentDescription: "",

    };
    this.dashboardTipoDocumentoService = new dashboardTipoDocumentoService();
  }

  componentDidMount() {
    this.getListTipoDocumento();
  }

  getListTipoDocumento() {
    this.setState({ loading: true });
    this.dashboardTipoDocumentoService.getTipoDocumento(
      (result) => {

        result.map((tipologiaDocumento) => {
            tipologiaDocumento.statobottne = true;
            tipologiaDocumento.bottoniEditi = true;

        });
        this.setState({ listTipoDocumento: result });
        this.setState({ listTipoDocumentoOld: result });
        this.setState({ loading: false });
      },
        ()=>{
            toast.error("Qualcosa è andato storto,Riprova");
            this.setState({ loading: false });
        }
    );
  }


  confermaElimina() {
    this.setState({ loadingButton: true})
    this.dashboardTipoDocumentoService.deleteTipoDocumento(
      this.state.idDaEliminare,
      (result) => {
        toast.success("Eliminato con successo");
        this.setState({ showDeleteModal: false });
        this.setState({ idDaEliminare: null });
        this.getListTipoDocumento();
        this.setState({ loadingButton: false });
      },
      ()=>{
        toast.error("Qualcosa è andato storto,Riprova");
        this.getListTipoDocumento();
        this.setState({ showDeleteModal: false });
        this.setState({ loadingButton: false });
      }
      );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="lg" show={this.state.showDeleteModal}>
          <Modal.Header>
            <Modal.Title>Elimina Tipo Documento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di eliminare Il Tipo Documento?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>{
                this.setState({ showDeleteModal: false })
                this.setState({ idDaEliminare: null })
              }
              }
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confermaElimina.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Elimina Tipo Documento"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }


  confermaAggiungi() {
    this.setState({ loadingButton: true });
    this.dashboardTipoDocumentoService.createTipoDocumento(
      {descrizione:this.state.newDocumentDescription},
      (result) => {
        this.setState({ loadingButton: false });

        toast.success("Aggiunto con successo");
        this.setState({showAddDocumentModal:false})
        this.setState({newDocumentDescription:""})
        this.getListTipoDocumento();
      },
      ()=>{
        this.setState({ loadingButton: false })
        this.setState({showAddDocumentModal:false})
        toast.error("Qualcosa è andato storto,Riprova")
        this.setState({newDocumentDescription:""})
      }
    );
  }


  newDocumentInputHandler(event) {
    this.setState({ newDocumentDescription: event.target.value });

  }

  addNewDocumentModal() {
    return (
      <>
        <Modal size="lg" show={this.state.showAddDocumentModal}>
          <Modal.Header>
            <Modal.Title>Aggiungi un nuovo tipo di Documento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Tipo Documento</label>
            <input
              className="form-control"
              type="text"
              value={this.state.newDocumentDescription}
              onChange={this.newDocumentInputHandler.bind(this)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>{
                this.setState({showAddDocumentModal:false})
                this.setState({newDocumentDescription:""})
              }}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton || this.state.newDocumentDescription.length < 1}
              onClick={this.confermaAggiungi.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Tipo Documento"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  onChangeEditTipoDocumento(event) {
    const index = event.target.id;
    let list = JSON.parse(JSON.stringify(this.state.listTipoDocumento));
    list[index].descrizione = event.target.value;
    this.setState({ listTipoDocumento: list });
  }

  confermaEditTipoDocumento(index){
    let doc = JSON.parse(JSON.stringify(this.state.listTipoDocumento[index]));
    let obj = {idTipoDocumento:doc.idTipoDocumento,descrizione:doc.descrizione,attivo:doc.attivo}

    this.dashboardTipoDocumentoService.editTipoDocumento(obj,(result)=>{
            this.getListTipoDocumento();
            toast.success("Modificato con successo");

    },()=>{
        toast.error("Qualcosa è andato storto")
        this.getListTipoDocumento();
    })
  }




  tabellaTipiDocumenti() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Tipo Documento</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listTipoDocumento.map((tipoDocumento, index) => {
              return (
                <>
                  <tr className="">
                    <th className="col-md-3">
                      <input
                        id={index}
                        disabled={tipoDocumento.statobottne}
                        className="form-control"
                        type="text"
                        value={tipoDocumento.descrizione}
                        onChange={this.onChangeEditTipoDocumento.bind(this)}
                      />
                    </th>
                    <td>
                      {tipoDocumento.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              let list = this.state.listTipoDocumento
                              let obj =  JSON.parse(JSON.stringify(list[index]))
                              obj.bottoniEditi = false
                              obj.statobottne = false
                              list[index] = obj
                              this.setState({listTipoDocumento:list})
                            }}>
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                idDaEliminare:tipoDocumento.idTipoDocumento,
                                showDeleteModal: true,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => this.confermaEditTipoDocumento(index)}>
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i>}
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              let list = JSON.parse(JSON.stringify(this.state.listTipoDocumento))
                              let obj =  list[index]
                              obj.bottoniEditi = true
                              obj.statobottne = true
                              obj.descrizione = this.state.listTipoDocumentoOld[index].descrizione

                              this.setState({listTipoDocumento:list})
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.TipologiaSanzione);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Tipo Documento<br></br>
            </h1>

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ showAddDocumentModal: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> Aggiungi
              una nuovo Tipo Documento
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaTipiDocumenti()}</div>
          {this.eliminaModal()}
           {this.addNewDocumentModal()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(DashboardTipoDocumento);
